import LoginPage from './LoginPageContainer'

export default LoginPage
